module.exports = __webpack_public_path__ + "img/2.7a2928e4.png";